export const styles = {
    legendText: {
        color: 'greyscale.700',
        fontFamily: 'Inter',
        fontSize: '10px',
        fontWeight: 400,
        lineHeight: '18px',
        letterSpacing: '0.2px'
    },
    legendWrapper: {
        left: 0,
        top: 24
    },
    barChartPosition: {
        left: 0,
        top: -16,
        right: 0
    },
    barChart: {
        stroke: '#FFF',
        strokeWidth: 2
    },
}